// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import { getAdminMenuItems } from 'menu-items/admins-menu';
import { getTeacherMenuItems } from 'menu-items/teachers-menu';

import { useRecoilValue } from 'recoil';
import { LoggedInState } from 'states/LoggedIn';
import { AcademyState } from 'states/Academy';
import { useSettings } from 'contexts/SettingsContext';

const MenuList = () => {
  const loggedIn = useRecoilValue(LoggedInState)
  const academyState = useRecoilValue(AcademyState)
  const { aiEvaluation } = useSettings();

  var menuItem = null;
  if (loggedIn.user.type === "A") {
    if (academyState == null) {
      // Use dynamic admin menu based on settings
      menuItem = getAdminMenuItems(aiEvaluation.isEnabled, loggedIn.user.academy_is_admin === true)
    } else {
      // Use dynamic teacher menu based on settings
      menuItem = getTeacherMenuItems(aiEvaluation.isEnabled)
    }
  } else if (loggedIn.user.type === "T") {
    // Use dynamic teacher menu based on settings
    menuItem = getTeacherMenuItems(aiEvaluation.isEnabled)
  }
  if (menuItem == null) {
    return <div>Wrong Access</div>
  }
  const navItems = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
